/**
 * El id de quien está dentro, del CosData que deja el login (15/10/2026).
 *
 * El mismo patrón del Calendario y de Solicitudes IA: usuario.id siempre,
 * idUsuarioSession desde el WAR del 22/09. Va aparte para que el
 * Seguimiento RH no copie el bloque. Solo sirve para no ofrecer lo que el
 * servidor va a rechazar (que RH cargue en lo propio); él lo vuelve a
 * comprobar, así que un CosData viejo solo puede apagar un botón de más.
 */
export function idEnSesion(): number | null {
  try {
    const raw = localStorage.getItem("CosData");
    const sesion = raw ? JSON.parse(raw) : null;
    const id = sesion?.idUsuarioSession ?? sesion?.usuario?.id;
    return id != null && !Number.isNaN(Number(id)) ? Number(id) : null;
  } catch {
    return null;
  }
}
